import { FacebookFeed } from 'ui/components';

export const FacebookFeedFeature: React.FC<Content.Linkbox> = () => {
	return <FacebookFeed />;
};
